import { REWARDS_WIDGET_NAMES } from "@/constants/widget-names";
import {
    RewardsAvailableRewardsB2BPageWidgetModalDefinition,
    RewardsAvailableRewardsPageWidgetModalDefinition,
    RewardsAvailableStoreCreditPageWidgetModalDefinition,
    RewardsJoinNowModalWidgetDefinition,
    RewardsQrCodeModalWidgetDefinition,
    RewardsRefundDiscountModalWidgetDefinition,
    RewardsVerifyAccountModalWidgetDefinition,
    RewardsWaysToEarnB2bPageWidgetModalDefinition,
    RewardsWaysToEarnPageWidgetModalDefinition,
    RewardsWaysToSpendB2bPageWidgetModalDefinition,
    RewardsWaysToSpendPageWidgetModalDefinition,
} from "@apps/rewards/constants/definitions";
import {
    rewardsAvailableRewardsPageWidgetModalToken,
    rewardsAvailableStoreCreditPageWidgetModalToken,
    rewardsJoinNowModalWidgetToken,
    rewardsQrCodeModalWidgetToken,
    rewardsRefundDiscountModalWidgetToken,
    rewardsVerifyAccountModalWidgetToken,
    rewardsWaysToEarnPageWidgetModalToken,
    rewardsWaysToSpendPageWidgetModalToken,
} from "@apps/rewards/tokens";

import type { ModalConfig } from "./types";

export const modalConfig: ModalConfig = {
    [REWARDS_WIDGET_NAMES.REWARDS_VERIFY_ACCOUNT_MODAL_WIDGET]: {
        definition: RewardsVerifyAccountModalWidgetDefinition,
        token: rewardsVerifyAccountModalWidgetToken,
    },
    [REWARDS_WIDGET_NAMES.REWARDS_JOIN_NOW_MODAL_WIDGET]: {
        definition: RewardsJoinNowModalWidgetDefinition,
        token: rewardsJoinNowModalWidgetToken,
    },
    [REWARDS_WIDGET_NAMES.REWARDS_QR_CODE_MODAL_WIDGET]: {
        definition: RewardsQrCodeModalWidgetDefinition,
        token: rewardsQrCodeModalWidgetToken,
    },
    [REWARDS_WIDGET_NAMES.REWARDS_WAYS_TO_EARN_PAGE_WIDGET_MODAL]: {
        definition: RewardsWaysToEarnPageWidgetModalDefinition,
        token: rewardsWaysToEarnPageWidgetModalToken,
    },
    [REWARDS_WIDGET_NAMES.REWARDS_WAYS_TO_EARN_B2B_PAGE_WIDGET_MODAL]: {
        definition: RewardsWaysToEarnB2bPageWidgetModalDefinition,
        token: rewardsWaysToEarnPageWidgetModalToken,
    },
    [REWARDS_WIDGET_NAMES.REWARDS_WAYS_TO_SPEND_PAGE_WIDGET_MODAL]: {
        definition: RewardsWaysToSpendPageWidgetModalDefinition,
        token: rewardsWaysToSpendPageWidgetModalToken,
    },
    [REWARDS_WIDGET_NAMES.REWARDS_WAYS_TO_SPEND_B2B_PAGE_WIDGET_MODAL]: {
        definition: RewardsWaysToSpendB2bPageWidgetModalDefinition,
        token: rewardsWaysToSpendPageWidgetModalToken,
    },
    [REWARDS_WIDGET_NAMES.REWARDS_AVAILABLE_REWARDS_PAGE_WIDGET_MODAL]: {
        definition: RewardsAvailableRewardsPageWidgetModalDefinition,
        token: rewardsAvailableRewardsPageWidgetModalToken,
    },
        [REWARDS_WIDGET_NAMES.REWARDS_AVAILABLE_REWARDS_B2B_PAGE_WIDGET_MODAL]: {
        definition: RewardsAvailableRewardsB2BPageWidgetModalDefinition,
        token: rewardsAvailableRewardsPageWidgetModalToken,
    },
    [REWARDS_WIDGET_NAMES.REWARDS_AVAILABLE_STORE_CREDIT_PAGE_WIDGET_MODAL]: {
        definition: RewardsAvailableStoreCreditPageWidgetModalDefinition,
        token: rewardsAvailableStoreCreditPageWidgetModalToken,
    },
    [REWARDS_WIDGET_NAMES.REWARDS_REFUND_DISCOUNT_MODAL_WIDGET]: {
        definition: RewardsRefundDiscountModalWidgetDefinition,
        token: rewardsRefundDiscountModalWidgetToken,
    },
} as const;
